import { render, staticRenderFns } from "./PolarAreaChart.vue?vue&type=template&id=d9bd12a4&"
import script from "./PolarAreaChart.vue?vue&type=script&lang=js&"
export * from "./PolarAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports